"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIDGET_REG_LOGIN_REMOTES_SETTINGS = void 0;
var settingsUtils_1 = require("./settingsUtils");
var types_1 = require("./types");
var settings = (0, settingsUtils_1.addFixSettingsIn)({
    type: types_1.MFE_TYPES.widgetRegLogin,
    skipImportingInCMS: false,
}, {
    cambioUsername: {
        __mfeName__: "cambioUsername",
        devClientPort: 6097,
        devServerPort: 6197,
    },
    tpdConfermaRegistrazione: {
        __mfeName__: "tpdConfermaRegistrazione",
        devClientPort: 6035,
        devServerPort: 6135,
    },
    tpdConfermaResetPassword: {
        __mfeName__: "tpdConfermaResetPassword",
        devClientPort: 6036,
        devServerPort: 6136,
    },
    tpdHomeArAzioniRapide: {
        __mfeName__: "tpdHomeArAzioniRapide",
        devClientPort: 7009,
        devServerPort: 7109,
    },
    tpdLoginHeader: {
        __mfeName__: "tpdLoginHeader",
        devClientPort: 6005,
        devServerPort: 6105,
        mfePriority: 1800,
    },
    tpdLoginHeaderNewArc: {
        __mfeName__: "tpdLoginHeaderNewArc",
        devClientPort: 6334,
        devServerPort: 6434,
        mfePriority: 1800,
    },
    tpdLoginWidget: {
        __mfeName__: "tpdLoginWidget",
        devClientPort: 6007,
        devServerPort: 6107,
        mfePriority: 1800,
    },
    tpdRegistrazioneClienti: {
        __mfeName__: "tpdRegistrazioneClienti",
        devClientPort: 6008,
        devServerPort: 6108,
    },
    tpdSuperUserWidget: {
        __mfeName__: "tpdSuperUserWidget",
        devClientPort: 6074,
        devServerPort: 6174,
        mfePriority: 2000,
    },
    tpdNavigazioneAssistitaWidget: {
        __mfeName__: "tpdNavigazioneAssistitaWidget",
        devClientPort: 6340,
        devServerPort: 6440,
    },
    tpdArCompletamentoRegistrazioneWidget: {
        __mfeName__: "tpdArCompletamentoRegistrazioneWidget",
        devClientPort: 6096,
        devServerPort: 6196,
    },
    tpdAggiornaProfiloWidget: {
        __mfeName__: "tpdAggiornaProfiloWidget",
        devClientPort: 6319,
        devServerPort: 6419,
    },
    tpdAggiornaProfiloEsitoWidget: {
        __mfeName__: "tpdAggiornaProfiloEsitoWidget",
        devClientPort: 6320,
        devServerPort: 6420,
    },
});
exports.WIDGET_REG_LOGIN_REMOTES_SETTINGS = settings;
